import React,{useState} from 'react'
import { BrowserRouter as Router} from "react-router-dom";
import icon from '../assets/icon.ico'
import { HashLink as Link} from 'react-router-hash-link';
import { useTranslation } from 'react-i18next';

function Navbar() {
    const [t, i18n] = useTranslation("global");
    const [navbar,setNavbar] = useState(false);

    const changeBackground = () =>{
        if(window.scrollY>=10){
            setNavbar(true);
        }else{
            setNavbar(false);
        }
    }
    window.addEventListener('scroll',changeBackground);

    return (
    <div>
        <nav className={navbar ? 'navbar active' : 'navbar'}>
            <div className='navbar-container'>
                <div className='navbar-left'>
                    <img src={icon} style={{width:'30px',height:'30px',paddingRight:'10px'}} alt='icon'/>
                    {/* <h3 className={navbar ? 'navbar-name active' : 'navbar-name'}>LEANDRO TATEOSSIAN</h3> */}
                </div>
                <div className='link-bar'>
                    <Router>
                        <Link to='#Header' smooth className={navbar ? 'navbar-link active' : 'navbar-link'}>{t("Home")}</Link>
                        <Link to='#Aboutme' smooth className={navbar ? 'navbar-link active' : 'navbar-link'}>{t("Aboutme")}</Link>
                        <Link to='#Lenguajes' smooth className={navbar ? 'navbar-link active' : 'navbar-link'}>{t("Skills")}</Link>
                        <Link to='#Portfolio' smooth className={navbar ? 'navbar-link active' : 'navbar-link'}>{t("Portfolio")}</Link>
                        <button onClick={()=>i18n.changeLanguage("es")} className={ i18n.language ==="es"?'navbar-locals-es active':'navbar-locals-es'}>ESP</button>
                        <button onClick={()=>i18n.changeLanguage("en")} className={ i18n.language ==="en"?'navbar-locals-en active':'navbar-locals-en'}>ENG</button>
                    </Router>
                </div>
            </div>
        </nav>
    </div>
    )
}

export default Navbar
